var _rect, _path, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDefaultCal = function SvgDefaultCal(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#FF5B55",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 7h16v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.997,
    height: 3,
    x: 3.968,
    y: 9,
    fill: "#FF5B55",
    rx: 0.25
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.997,
    height: 3,
    x: 10.961,
    y: 13,
    fill: "#FF5B55",
    rx: 0.25
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultCal);
export { ForwardRef as Icon };
export default "img/element-icons/room/default_cal.548061c.svg";